module.exports = __webpack_public_path__ + "static/media/enfant.4b0d1879.png";